/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

document.addEventListener('product:added', function(event) {
	console.log('product:added', event);
  hideSideCart(parseInt("2000"));
});

document.addEventListener('product:quantityChanged', function(event) {
	console.log('product:quantityChanged', event);
});

let accordionButtons = document.querySelectorAll('.Data_link');
let clickValue = 0;
for (let accordionButton of accordionButtons){

	accordionButton.addEventListener('click', function(){
		let ariaDirect =  accordionButton.getAttribute('data-href');
		window.location.href = ariaDirect;
	});
}

// hide the sidecart after 'delay' milliseconds
let sideCartWasClicked = false;
const sidebarCart = document.querySelector('#sidebar-cart')
if (sidebarCart) {
	sidebarCart.addEventListener('click', function(event) {
		sideCartWasClicked = true;
	})
}
function hideSideCart(delay) {
  setTimeout(function() {
  	if (!sideCartWasClicked) {
	  	$('#sidebar-cart .Drawer__Close').trigger('click');
  	}
  	sideCartWasClicked = false;
  }, delay);
}

// connect continue button to the close button
$('.Cart__ContinueBtn').on('click', function(event) {
	$('#sidebar-cart .Drawer__Close').trigger('click');
})

// reattach listeners on the cart page after a quantity change / rerender
document.addEventListener('cart:rerendered', function(event) {
  $('form input:not([type="submit"])').on("keypress", function(event) {
    if (event.key == "Enter") {
      console.log(event);
      $(event.target).blur();
      event.preventDefault();
    }
  });
  $('.UpdateButton').on('click', function(event) {
    console.log('from custom js');
  })
});
